import { money } from "./meta";

const secs = (s) => { const n = Number(s || 0); return `${Math.floor(n / 60)}:${String(n % 60).padStart(2, "0")}`; };

export function CallsTable({ rows, onOpen }) {
  return (
    <table className="w-full text-xs" data-testid="uc-calls-table">
      <thead className="sticky top-0 bg-white"><tr className="border-b border-slate-100 text-left text-[11px] uppercase tracking-wide text-slate-500">
        <th className="px-4 py-2 font-semibold">UTC time</th><th className="px-3 py-2 font-semibold">Domain</th><th className="px-3 py-2 font-semibold">Ext</th>
        <th className="px-3 py-2 font-semibold">From (ANI)</th><th className="px-3 py-2 font-semibold">Dialled</th><th className="px-3 py-2 font-semibold">Type / region</th>
        <th className="px-3 py-2 text-right font-semibold">Billed</th><th className="px-3 py-2 text-right font-semibold">Revenue</th></tr></thead>
      <tbody>{rows.map((r) => (
        <tr key={r.id} onClick={() => onOpen(r.id)} className="cursor-pointer border-b border-slate-50 hover:bg-emerald-50/40" data-testid={`uc-call-${r.id}`}>
          <td className="whitespace-nowrap px-4 py-1.5 font-mono text-slate-700">{r.utc}</td>
          <td className="px-3 py-1.5"><span className="font-medium text-slate-800">{r.domain}</span><span className="block text-[11px] text-slate-500">{r.territory}</span></td>
          <td className="px-3 py-1.5 font-mono">{r.ext}</td>
          <td className="px-3 py-1.5 font-mono">{r.ani}</td>
          <td className="px-3 py-1.5 font-mono">{r.dialled}</td>
          <td className="px-3 py-1.5 text-slate-600">{r.call_type}<span className="block text-[11px] text-slate-500">{r.region}</span></td>
          <td className="px-3 py-1.5 text-right font-mono tabular-nums">{secs(r.billed)}</td>
          <td className={`px-3 py-1.5 text-right font-mono tabular-nums ${Number(r.revenue) > 0 ? "font-semibold text-slate-900" : "text-slate-400"}`}>{money(r.revenue)}</td>
        </tr>))}</tbody>
    </table>
  );
}
